(() => {
  if (window.__smoofSampleBoxV1) return;
  window.__smoofSampleBoxV1 = true;
  const handle = 'smoof-musterbox';
  const root = window.Shopify?.routes?.root || '/';
  const rowSelector = '[data-smoof-sample-line]';
  let adding = false;
  let queued = false;
  const language = (document.documentElement.lang || 'de').split('-')[0];
  const texts = language === 'en' ? {
    limit: 'Only one sample box is allowed per order. Please remove any additional sample boxes.',
    adding: 'Adding your sample box…', exists: 'Your sample box is already in the cart.',
    error: 'The cart could not be updated. Please try again.',
  } : language === 'it' ? {
    limit: 'È consentita una sola confezione campione per ordine. Rimuova le confezioni aggiuntive.',
    adding: 'Aggiunta della confezione campione…', exists: 'La confezione campione è già nel carrello.',
    error: 'Impossibile aggiornare il carrello. Riprovi.',
  } : {
    limit: 'Pro Bestellung ist eine Musterbox möglich. Bitte entfernen Sie zusätzliche Musterboxen.',
    adding: 'Ihre Musterbox wird hinzugefügt…', exists: 'Ihre Musterbox liegt bereits im Warenkorb.',
    error: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
  };

  // UI convenience only. An active Shopify checkout validation must enforce the
  // aggregate product quantity server-side, including separate properties/lines.
  function invalidCart(scope) {
    return Array.from(scope.querySelectorAll(rowSelector)).reduce((sum, row) =>
      sum + Number(row.dataset.smoofSampleQuantity || 0), 0) > 1;
  }

  const sampleNavLabel = language === 'en' ? 'Sample box' : language === 'it' ? 'Box campioni' : 'Musterbox';
  function updateVectronNavigation() {
    const collectionPath = window.location.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)/i);
    if (collectionPath?.[1] !== 'vectron') return;
    document.querySelectorAll('a[href], summary[data-link]').forEach(link => {
      const attr = link.hasAttribute('href') ? 'href' : 'data-link';
      let url;
      try { url = new URL(link.getAttribute(attr), window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin || !['#anwendung', '#musterbox'].includes(url.hash)) return;
      if (!/\/collections\/vectron\/?$/.test(url.pathname)) return;
      url.hash = 'musterbox';
      link.setAttribute(attr, url.pathname + url.search + url.hash);
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const label = node.textContent.replace(/Anwendungsfälle|Use Cases|Casi d[’']uso|Musterbox|Sample box|Box campioni/gi, sampleNavLabel);
        if (node.textContent !== label) node.textContent = label;
      }
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', sampleNavLabel);
    });
  }
  function update() {
    queued = false;
    updateVectronNavigation();
    document.querySelectorAll('[data-smoof-sample-form] button[type="submit"], [data-smoof-sample-image]').forEach(button => {
      button.disabled = adding;
    });
    document.querySelectorAll(rowSelector).forEach(row => {
      const input = row.querySelector('input[name="updates[]"]');
      if (input) input.max = '1';
      const plus = row.querySelector('button[name="plus"]');
      if (plus) plus.disabled = true;
    });
    // Each section has its own message, avoiding double counting a cart drawer
    // and full cart that happen to be present in the same document.
    document.querySelectorAll('[data-smoof-sample-cart-message]').forEach(message => {
      const scope = message.closest('.shopify-section') || message.closest('cart-items') || document;
      const invalid = invalidCart(scope);
      message.hidden = !invalid;
      if (message.textContent !== texts.limit) message.textContent = texts.limit;
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  function blockInvalidCheckout(event, target) {
    const scope = target.closest('.shopify-section') || document;
    if (!invalidCart(scope)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    update();
    scope.querySelector('[data-smoof-sample-cart-message]')?.focus();
  }
  async function readCart() {
    const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(texts.error);
    return response.json();
  }
  async function addSample(form) {
    if (adding) return;
    adding = true;
    update();
    const status = form.querySelector('[data-smoof-sample-status]');
    const say = text => { if (status) status.textContent = text; };
    try {
      say(texts.adding);
      const cart = await readCart();
      const alreadyPresent = cart.items.some(item =>
        item.handle === handle || String(item.product_id) === form.dataset.productId);
      if (alreadyPresent) {
        say(texts.exists);
      } else {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error(texts.error);
      }
      // Re-read after adding: preserve existing carts and their regular-product
      // quantity checks. A single sample alone goes straight to guest checkout.
      const latest = await readCart();
      const sampleOnly = latest.items.length > 0 && latest.items.every(item =>
        item.handle === handle || String(item.product_id) === form.dataset.productId);
      const quantity = latest.items.reduce((sum, item) => sum + Number(item.quantity), 0);
      window.location.assign(sampleOnly && quantity === 1 ? `${root}checkout` : (form.dataset.cartUrl || `${root}cart`));
    } catch (error) {
      say(texts.error);
    } finally {
      adding = false;
      update();
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-smoof-sample-form]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      // Serialize sample-box clicks across tabs where Web Locks are supported.
      if (navigator.locks?.request) navigator.locks.request('smoof-sample-box', () => addSample(form));
      else addSample(form);
      return;
    }
    if (event.submitter?.matches('[name="checkout"]')) blockInvalidCheckout(event, form);
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const checkout = event.target.closest('[name="checkout"], a[href$="/checkout"], [data-smoof-moq-accelerated]');
    if (checkout) blockInvalidCheckout(event, checkout);
  }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('input[name="updates[]"]') || !input.closest(rowSelector)) return;
    const value = Number(input.value);
    if (Number.isInteger(value) && value >= 0 && value <= 1) return;
    input.value = '1';
    // Let the theme submit the corrected quantity. Removal (0) remains valid.
  }, true);
  document.addEventListener('cart:refresh', queue);
  document.addEventListener('shopify:section:load', queue);
  new MutationObserver(queue).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-smoof-sample-quantity'],
  });
  update();
})();
